// components/feedback

import template from './modal.jade'
import style    from './style.scss'
import Store    from 'Store'

var name = 'feedback'
var url = 'api/feedback'
const store = new Store(name)

export default {

  name: name,
  template: template({style: style}),

  data: () => ({
    name: name,
    url: url,
    show: true,
    blockForm: false,
    feedback: null,
  }),

  methods: {
    // отправляем данные формы на сервер
    submit(e) {
      e.preventDefault()
      this.$set('blockForm', true)
      this.$set('data.feedback', this.feedback)
      this.$set('data.name_expeditor', store.$get('name_expeditor') )
      this.$set('data.email', store.$get('email') )
      this.$set('data.phone', store.$get('phone') )
      store.$save(this)
    },
    // при закрытии окна возвратимся по истории назад и сбросим форму
    onClick(e) {
      e.preventDefault()
      this.blockForm = this.feedback = this.data = null
      this.$set('show', true)
      var from = this.$route.router._currentTransition.from.name || 'index'
      this.$route.router.go({ name: from })
    },
  },

  events: {
    // если все ок, скроем поля формы
    'fetchData:ok': function() {
      this.$set('blockForm', false)
      this.$set('show', false)
    },
  },

}



/** WEBPACK FOOTER **
 ** ./src/js/components/feedback/index.js
 **/